export const colors = {
    PURPLE_COLOR: 'purple_color',
    BLUE_COLOR: 'blue_color',
    RED_COLOR: 'red_color',
    RED_CHECK: 'red_check',
    ORANGE_COLOR: 'orange_color',
};
